import { render, staticRenderFns } from "./PrepList.vue?vue&type=template&id=7951521c&scoped=true"
import script from "./PrepList.vue?vue&type=script&lang=js"
export * from "./PrepList.vue?vue&type=script&lang=js"
import style0 from "./PrepList.vue?vue&type=style&index=0&id=7951521c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7951521c",
  null
  
)

export default component.exports